import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import { ReactComponent as LoadingIconWhite } from 'assets/mobile-assets/loading-Icon-white.svg';
import { ReactComponent as LoadingIconBlue } from 'assets/mobile-assets/loading-icon-blue.svg';
import { Z_LAYERS } from 'app/pages/mobile/utils/constants';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

interface MobileLoadingOverlayProps {
  isLoading: boolean;
  invert?: boolean;
}

const MobileLoadingOverlay = ({ isLoading, invert = false }: MobileLoadingOverlayProps) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        zIndex: Z_LAYERS.MOBILE_LOADING_OVERLAY,
      }}
    >
      <Box
        sx={{
          width: '80px',
          height: '80px',
          animation: `${spin} 1s linear infinite`,
        }}
      >
        {invert ? (
          <LoadingIconWhite style={{ width: '100%', height: '100%' }} />
        ) : (
          <LoadingIconBlue style={{ width: '100%', height: '100%' }} />
        )}
      </Box>
    </Box>
  );
};

export default MobileLoadingOverlay;
